import { useEffect } from 'react';

interface UseKeyDownArgs {
  key: string;
  action: (event: KeyboardEvent) => void;
}

export const useKeyDown = ({ key, action }: UseKeyDownArgs) => {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === key) {
        action(event);
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [action, key]);
};
